var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-content-page"},[_c('div',{staticClass:"page-container"},[(_vm.objectHasValue(_vm.content))?_c('DynamicZone',{attrs:{"blocks":_vm.content.Blocks}}):_vm._e()],1),_c('TheFooter',{attrs:{"is-authenticated":_vm.isAuthenticated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }